<template>
  <div id="app">
    <transition name="fade">
      <router-view/>
    </transition>
  </div>
</template>

<script>
  import {mapActions} from 'vuex';
export default {
  methods:{
    ...mapActions(['selectRandomLoader'])
  },
  created() {
    this.selectRandomLoader()
  }
}
</script>

<style lang="scss">
@import "./styles/main.scss";

.fade-enter-active {
  transition: opacity 0.3s ease-in-out;
}
.fade-enter {
  opacity: 0;
}
.fade-leave-active {
  transition: opacity 0.3s ease-in-out;
}
.fade-leave-to {
  opacity: 0;
}
</style>
